import styled from "styled-components";
import { Label, Spacer } from "../editor/EditorHelpers";
import { useEffect, useState } from "react";

// Styled components
const Container = styled.div`
  /* margin-bottom: 1rem; */
`;

const Input = styled.input`
  width: 100px;
  height: 34px;
  padding: 1px 2px;
  border: 1px solid var(--border-color);
  border-radius: 0.25rem;
`;

export interface BackgroundProps {
  backgroundImage?: string;
  backgroundPosition?: string;
  backgroundSize?: string;
  backgroundColor: string;
}

interface BackgroundPickerProps {
  label?: string;
  defaultColor?: string;
  defaultImage?: string;
  onChange: (newValue: BackgroundProps) => void; // a string to use as a css background property
}

export default function BackgroundPicker(props: BackgroundPickerProps) {
  const { label, defaultColor, defaultImage, onChange } = props;
  const [imageUrl, setImageUrl] = useState<string | null>(defaultImage || null);
  const [color, setColor] = useState<string>(defaultColor || '#FFFFFF');

  const outValueFromParts: () => BackgroundProps = () => {
    if (!imageUrl) {
      return { backgroundColor: color };
    }
    return {
      backgroundColor: color,
      backgroundImage: `url('${imageUrl}'`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }
  };

  const [debouncedChange, setDebouncedChange] = useState<BackgroundProps>(outValueFromParts());

  // Debounce changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedChange(outValueFromParts());
    }, 350);

    // Cleanup function to clear the timeout
    return () => {
      clearTimeout(handler);
    };
  }, [imageUrl, color]);

  useEffect(() => {
    onChange(debouncedChange)
  }, [debouncedChange]);


  useEffect(() => {

  }, [imageUrl, color]);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImageUrl(URL.createObjectURL(file));
    }
  }

  const BackgroundButton = ({ myImageUrl }) => {
    return (
    <Button 
      onClick={() => setImageUrl(myImageUrl)}
    >
      <ButtonImg src={myImageUrl || '/clear.jpg'} />
    </Button>)
  }

  return (
    <Container>
      {!!label && <Label>{label}</Label>}
      <Row>
        <BackgroundButton myImageUrl='/green_background.jpg' />
        <BackgroundButton myImageUrl='/solid_background.jpg' />
        <BackgroundButton myImageUrl='/tools_background_grey.jpg' />
        <BackgroundButton myImageUrl={null} />
      </Row>
      <Spacer />
      <Row>
        <Input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        />
        <FileInput type="file" accept="image/*" onChange={handleImageChange} />
      </Row>
    </Container>
  );
};

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FileInput = styled.input`
  flex-grow: 1;
`;

/*
  border: 1px solid var(--border-color); 
  border-radius: 0.25rem;
*/
const Button = styled.button`
  border: 1px solid var(--border-color); 
  border-radius: 0.25rem;
  padding: 5px 5px;
  vertical-align: middle;
`;


const ButtonImg = styled.img`
  width: auto;
  height: 32px;
  vertical-align: middle;
`;

